<template>
    <v-container style="padding-top:80px">
        <div v-if="loading" id="cargando" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <div v-else>
            <div v-if="failure">
                <div class="d-flex justify-center">
                    <VCard class="pa-8" :width="'40%'" :max-width="'40%'">
                        <div v-if="message">
                            <p class="text-center text-lg pt-10">{{ message }}</p>
                        </div>
                    </VCard>
                </div>
            </div>
            <div v-else>
                <v-row mb-2>
                    <v-chip class="ma-2 chipSize" :color="data.color" style="align-self: center" large>
                        <span class="txtRep"> Reporte: {{ data.nrreporte }}-{{ data.svindice }} </span>
                    </v-chip>
                    <v-chip :class="colorClass" class="chipSize" style="align-self: center" large>
                        <span class="txtEtiq">
                            {{ data.etiqueta }}
                        </span>
                    </v-chip>
                </v-row>
                <div class="d-flex justify-center">
                    <VCard class="mt-4 pa-8" :width="'40%'" :max-width="'40%'">
                        <p class="text-center text-gray-600">Tipo: {{ data.tipo }}</p>
                        <div v-if="message">
                            <p class="text-center text-lg pt-10">{{ message }}</p>
                        </div>
                        <div v-else>
                            <h3 class="text-center text-black text-xl font-semibold pt-3">{{ data.docarchivo }}</h3>
                            <div id="escuchar" class="text-center py-3 w-100" />
                        </div>
                    </VCard>
                </div>
            </div>
        </div>

    </v-container>
</template>

<script>
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import Archivos from '@/services/Archivos/Archivos.service.js';
import Reporte from "@/services/ExpJur/ExpJur.service.js";

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
    },
    data: function () {
        return {
            data: {
                nrreporte: null,
                svindice: null,
                docid: null,
                pagina: 1,
                linkExp: new Date().setDate(new Date().getDate() + 15),
                tipo: null,
                aiclave: null,
                color: null,
                etiqueta: ''
            },
            fileData: {
                watch: '',
                archivo: null,
                correcto: false,
                error: true
            },
            loading: true,
            message: null,
            colorClass: null,
            failure: false
        }
    },
    computed: {

    },
    async mounted() {

        let encryptedData = this.$route.query.data

        if (encryptedData != null && encryptedData != undefined)
            await this.DecryptData(encryptedData).then(() => this.loading = false)

    },
    watch: {
        'data.etiqueta'(val) {
            if (val == "Abierto") {
                this.colorClass = "marginChip";
            } else if (val == "Concluido") {
                this.colorClass = "marginChipRed";
            } else if (val == "Cancelado") {
                this.colorClass = "marginChipPurple";
            } else if (val == "Conclusión Administrativa") {
                this.colorClass = "marginChipYellow";
            }
        },
    },
    methods: {
        async DecryptData(val) {
            await MetodosGenerales.decryptData(val).then(async res => {
                this.data = res
                let baseDate = await MetodosGenerales.obtenerFechaHoraBase()
                const exp = new Date(res.exp)
                const now = new Date(baseDate.fechaHora)
                this.failure = exp <= now
                if (exp <= now)
                    this.message = "Lamentamos las molestias, pero el enlace ha expirado."
                else {
                    await Reporte.EncabezadoReporteParams(res.nrreporte, res.svindice, res.aiclave).then((enc) => {
                        this.data = { ...this.data, color: enc.color, etiqueta: enc.etiqueta }
                    });
                    await Archivos.ObtenerDireccion({ nrreporte: res.nrreporte, svindice: res.svindice }, res.docid, this.data.pagina)
                        .then(async file => {
                            this.fileData = file
                            if (file.error == false)
                                await this.setFile()
                            else
                                this.message = "No se pudo obtener el archivo."
                        })
                }
            }).catch(err => {
                this.failure = true
                this.message = "Hubo un error al obtener la información."
            });
        },
        async setFile() {
            var formData = new FormData();
            formData.append("lasitio", 'Prusia+');
            formData.append("lomodulo", "Llamadas");
            formData.append("laaccion", "Escuchó Audio");
            formData.append("lacaracteristicas", this.data.nrreporte + '-' + this.data.svindice);
            formData.append("lanombre", this.fileData.archivo);
            formData.append("ladestinatario", "");

            await Archivos.AlmacenarVisitas(formData).then(() => this.loading = false);

            if (this.fileData.archivo !== null) {

                let listen = document.getElementById("escuchar")
                let audio = document.createElement('audio');
                audio.style.margin = '0 auto';
                audio.style.width = '100%'
                audio.src = this.fileData.watch;
                audio.controls = true;
                audio.autoplay = true;
                audio.controlsList = "nodownload";
                listen.appendChild(audio);
            }
            else {
                this.$swal({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: dir.msg,
                    showConfirmButton: true,
                    confirmButtonColor: '#536DFE',
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: false,
                });
            }
        }
    }
}

</script>